<template>
  <div class="animated fadeIn form-abm">
    <b-row>
      <b-col xl="12">
        <b-card header= "Información del Recurso">
          <b-form>
            <b-form-group
              label="Apellido"
              label-for="apellido"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="apellido"
                class="text-upper"
                v-model.trim="$v.apellido.$model" 
                :state="apellidoValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="apellidoFeedback">
                {{ apellidoInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              label="Nombre"
              label-for="nombre"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="nombre"
                class="text-upper"
                v-model.trim="$v.nombre.$model" 
                :state="nombreValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="nombreFeedback">
                {{ nombreInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              label="Nro.Documento"
              label-for="documentoNumero"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="documentoNumero"
                v-model.trim="$v.documentoNumero.$model" 
                :state="documentoNumeroValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="documentoNumeroFeedback">
                {{ documentoNumeroInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <!-- <b-form-group
              label="Pais"
              label-for="pais"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="pais"
                :value="pais" 
                type="text"
                readonly>
              </b-form-input>
            </b-form-group> -->

            <!-- <b-form-group
              label="Fecha de Nacimiento"
              label-for="fechaNacimiento"
              :label-cols="labelCols">
              <b-input-group>
                <b-input-group-prepend is-text>
                  <b-form-checkbox 
                      id="fechaNacimientoHabilitada"
                      v-model="fechaNacimientoHabilitada"
                      value= true
                      unchecked-value= false>
                  </b-form-checkbox>
                </b-input-group-prepend>
                <b-form-input 
                  id="fechaNacimiento" 
                  v-model="$v.fechaNacimiento.$model" 
                  type="date"
                  :disabled= "fechaNacimientoDisabled"
                  :state="fechaNacimientoValida"
                  @blur.native="validate">
                </b-form-input>
              </b-input-group>
              <b-form-invalid-feedback id="fechaNacimientoFeedback">
                {{ fechaNacimientoInvalidaMsj }}
              </b-form-invalid-feedback>          
            </b-form-group> -->

            <div class="grupo-controles">
              <b-form-group
                label="Nro Celular"
                label-for="nroCelular"
                :label-cols="2"
                horizontal>
                <b-form-input 
                  id="prefijo"
                  v-model.trim="$v.prefijo.$model" 
                  :state="prefijoValido"
                  type="text"
                  @blur.native="validate">
                </b-form-input>
                <b-form-input 
                  id="celular"
                  v-model.trim="$v.celular.$model" 
                  :state="celularValido"
                  type="text"
                  @blur.native="validate">
                </b-form-input>
                <b-form-invalid-feedback id="nroCelularFeedback">
                  {{ nroCelularInvalidoMsj }}
                </b-form-invalid-feedback>          
              </b-form-group>
            </div>

            <b-form-group
              label="Email"
              label-for="email"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="email"
                v-model.trim="$v.email.$model" 
                :state="emailValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="emailFeedback">
                {{ emailInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>
          </b-form>
        </b-card>
      </b-col>
    </b-row>

    <app-a-b-m-button
      @save="save"
      @cancel="goList">
    </app-a-b-m-button>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      :modalVariant="modalVariant"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import ABMButtons from '../shared/abmButtons.vue';
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'
import { required, requiredIf, numeric, maxLength, email } from 'vuelidate/lib/validators';
import { createHelpers } from 'vuex-map-fields';
import moment from 'moment';

const { mapFields } = createHelpers({
  getterType: 'staffRecurso/getField',
  mutationType: 'staffRecurso/updateField',
});

export default {
  name: 'StaffABM',
  components: {
    appABMButton: ABMButtons,
    appMensaje: Mensaje
  },
  mixins: [ 
    msjModal, 
  ],
  data () {
    return {
      noValidar: true,
      apellidoValido: null,
      apellidoInvalidoMsj: '',
      nombreValido: null,
      nombreInvalidoMsj: '',
      documentoNumeroValido: null,
      documentoNumeroInvalidoMsj: '',
      // fechaNacimientoValida: null,
      // fechaNacimientoInvalidaMsj: '',
      prefijoValido: null,
      celularValido: null,
      nroCelularInvalidoMsj: '',
      emailValido: null,
      emailInvalidoMsj: '',

      labelCols: 2,

      fechaNacimientoDisabled: true,
    }
  },
  computed: {
    ...mapFields([
      'id',
      'apellido',
      'nombre',
      'documentoNumero',
      // 'fechaNacimiento',
      // 'fechaNacimientoHabilitada',
      'pais',
      'prefijo',
      'celular',
      'email',
    ]),
  },  
  created() {
    let staffId = 0;
    if (this.$route.params){
      if (this.$route.params.id){
        staffId = this.$route.params.id;
      }
    }

    console.log(staffId);
    this.showSpinner();
    this.$store.dispatch('staffRecurso/inicializar', staffId)
      // .then(() => {
      //   if (moment(this.fechaNacimiento).format('YYYY-MM-DD') == '1900-01-01') {
      //     this.fechaNacimientoDisabled = true;
      //   } else {
      //     this.fechaNacimientoDisabled = false;
      //   }
      // })
      .catch(error => this.showErrorMsj(error))
      .finally(() => this.hideSpinner());
  },  
  methods: {
    // getDatosAdicionales() {
    //   const vm = this;

    //   if (!(/true/i).test(this.eventoWhapp)) {
    //     this.loading = true;
    //     this.$store.dispatch('generos/getList')
    //       .then(() => {
    //         vm.generosList = this.$store.getters['generos/list'];
    //         this.loading = false;
    //       })
    //       .catch(() => this.showErrorMsj('Se produjo un error al recuperar la información de géneros.'));        
    //   }
    // },

    validate(event) {
      if (event) {
        if (event.target) {
          /* Antes de intentar registrar por primera vez, no validamos */
          if (!this.noValidar)
          {
            this.$v.$touch();
            this.displayErrores(event.target.id);
          }
        }
      } 
    },
    displayErrores(field) {
      var validarTodos = false;
      var campo = '';

      if (field) {
        campo = field;
      } else {
        validarTodos = true;
      }

      if (campo == 'apellido' || validarTodos) {
        if (this.$v.apellido.$error) {
          this.apellidoValido = false;
          if (!this.$v.apellido.required) {
            this.apellidoInvalidoMsj= 'Debe ingresar el apellido del participante.';
          } else if (!this.$v.nombre.maxLength) {
            this.apellidoInvalidoMsj = 'El apellido solo puede contener hasta 255 caracteres';
          } 
        } else {
          this.apellidoValido = null;
          this.apellidoInvalidoMsj = '';
        }
      }

      if (campo == 'nombre' || validarTodos) {
        if (this.$v.nombre.$error) {
          this.nombreValido = false;
          if (!this.$v.nombre.required) {
            this.nombreInvalidoMsj= 'Debe ingresar el nombre del participante.';
          } else if (!this.$v.nombre.maxLength) {
            this.nombreInvalidoMsj = 'El nombre solo puede contener hasta 255 caracteres';
          } 
        } else {
          this.nombreValido = null;
          this.nombreInvalidoMsj = '';
        }
      }

      if (campo == 'prefijo' || validarTodos) {
        if (this.$v.prefijo.$error) {
          this.prefijoValido = false;
          if (!this.$v.prefijo.numeric) {
          } 
        } else {
          this.prefijoValido = null;
        }
      }

      if (campo == 'celular' || validarTodos) {
        if (this.$v.celular.$error) {
          this.celularValido = false;
          if (!this.$v.celular.numeric) {
          } 
        } else {
          this.celularValido = null;
        }
      }

      if (this.prefijoValido == false || this.celularValido == false) {
        this.nroCelularInvalidoMsj = 'El número o prefijo de celular ingresado no es válido.';
      } else {
        this.nroCelularInvalidoMsj = '';
      }

      if (campo == 'email' || validarTodos) {
        if (this.$v.email.$error) {
          this.emailValido = false;
          if (!this.$v.email.email) {
            this.emailInvalidoMsj= 'La dirección de correo electrónico no parece ser válida.';
          } 
        } else {
          this.emailValido = null;
          this.emailInvalidoMsj = '';
        }
      }
    },
    save () {
      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;

      this.$v.$touch();

      let save = true;

      if (this.$v.$anyError) {
        this.displayErrores();
      } else {
        if (save) {
          this.showSpinner();
          this.$store.dispatch('staffRecurso/save')
            .then(()  => this.showModalMsj('Los cambios se registraron con éxito.', this.goList, this.goList, 'light'))
            .catch(error => this.showErrorMsj(error))
            .finally(() => this.hideSpinner())
        } 
      }
    },
    objetoValido(objeto, objetoNombre, objetoList, objetoDispatch, validar, 
        objetoValido, objetoInvalidoField, objetoInvalidoMsj) {
      let isValido = true;
      let selected = null;
      if (objetoNombre) {
        selected = this.getSelected(objetoList, objetoNombre);
      }
      this.$store.dispatch('staffRecurso/' + objetoDispatch, selected);

      let objetoStore = this.$store.getters['staffRecurso/' + objeto];

      if (validar) {
        if (objetoStore) {
          if (objetoStore.id) {
            if (objetoStore.id != 0) {
              isValido = false;
            }
          }
        }
        if (!isValido) {
          objetoValido = false;
          objetoInvalidoField = objetoInvalidoMsj;
        }
      }
      return isValido;
    },
    goList() {
      this.$router.push({ name: 'Staff' });
    },
  },
  watch: {
    // 'fechaNacimientoHabilitada' : function(newVal, oldVal) {
    //   this.fechaNacimientoDisabled = !(/true/i).test(this.fechaNacimientoHabilitada);
    // },
  },
  validations: {
    documentoNumero: {
      required,
      maxLength: maxLength(50)
    },
    nombre: {
      required,
      maxLength: maxLength(255)
    },
    apellido: {
      required,
      maxLength: maxLength(255)
    },
    prefijo: {
      numeric
    },
    celular: {
      numeric
    },
    email: {
      email,
      maxLength: maxLength(255)
    },
    // fechaNacimiento: {},
  },  
}
</script>

<style>
  .form-abm .grupo-controles input {
    display: inline-block;
  }
  .form-abm .grupo-controles input#prefijo {
    width: Calc(30% - 15px);
  }
  .form-abm .grupo-controles input#celular {
    width: 70%;
    margin-left: 15px;
  }
</style>
